// Replaces {{name}} placeholders in CMS texts (spaces inside the braces allowed). Unknown placeholders become empty,
// so a typo in Directus never shows raw braces to players.
export function fillPlaceholders(text: string, values: Record<string, string | number>): string {
    return text.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (_, name: string) => {
        const value = values[name.toLowerCase()];
        return value == null ? "" : String(value);
    });
}
